module.exports = __webpack_public_path__ + "img/logotipo.d7e750c1.png";